import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { OnlineCheckoutRequest, OnlineCheckoutResponse, LineItem } from "../models/online-checkout/online-checkout.interface";
import { environment } from "../../environments/environment";

const { baseUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class OnlineCheckoutService {
  constructor(private httpClient: HttpClient) {}

  createOnlineCheckout(order_number: string, amount: number, merchant_id: string, line_items: LineItem[], authToken: string, idempotency_key: string): Observable<OnlineCheckoutResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
        idempotency_key: idempotency_key,
      }),
    };

    const bodyContent: OnlineCheckoutRequest = {
      order_number,
      amount,
      merchant_id,
      currency: "CLP",
      description: "Compra Online",
      source: "billing",
      success_url: `${window.location.origin}/charge`,
      success_url_method: "POST",
      cancel_url: `${window.location.origin}/charge`,
      cancel_url_method: "POST",
      payment_method_types: "card",
      mode: "payment",
      line_items,
      accept_partial_authorization: false,
      installments_enabled: false,
      accept_3d_secure: false,
      tokenization_enable: false,
      livemode: false,
    };

    return this.httpClient.post<OnlineCheckoutResponse>(`${baseUrl}/onlinecheckout`, bodyContent, httpOptions);
  }

  updateOnlineCheckout(id: string, amount: number, line_items: LineItem[], authToken: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }),
    };

    const bodyContent = {
      line_items,
      amount,
    };

    return this.httpClient.put<any>(`${baseUrl}/onlinecheckout/${id}`, bodyContent, httpOptions).pipe(
      catchError((error) => {
        console.error("PUT Update failed, trying PATCH:", error);
        // Intentar con PATCH si PUT falla
        return this.httpClient.patch<any>(`${baseUrl}/onlinecheckout/${id}`, bodyContent, httpOptions);
      })
    );
  }

  cancelCheckout(id: string, merchantId: string, authToken: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }),
    };

    const bodyContent = {
      reason: "canceled_by_payer",
      merchant_id: merchantId,
    };

    return this.httpClient.post<any>(`${baseUrl}/onlinecheckout/${id}/cancel`, bodyContent, httpOptions);
  }
}
